<template><div><h1>VUX V2.7.1 发布日志</h1>
<h2><a href="/zh-CN/components/datetime.html">Datetime</a></h2>
<ul><li>[fix] 修复插件使用时 less 变量不生效问题 #2152</li>
</ul>
<h2><a href="/zh-CN/components/x-button.html">XButton</a></h2>
<ul><li>[enhance] 链接支持对象类型 #2068</li>
</ul>
<h2><a href="/zh-CN/components/x-dialog.html">XDialog</a></h2>
<ul><li>[fix] 修复 prevent-body-scroll.css 无法找到问题(less-loader) #2118</li>
</ul>
<h2><a href="/zh-CN/components/x-input.html">XInput</a></h2>
<ul><li>[fix] 修复数字为 0 时 valid 为 false 的问题 #2134</li>
<li>[fix] 修复 on-blur 事件没有正确触发的问题 #2146</li>
</ul></div></template><script>
export default {
  head: {"title":"VUX V2.7.1 发布日志 | VUX - 基于 WeUI 和 Vue 的移动端组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v2.7.1-259.vue?4b8449fe